module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    class: ("c-json-p c-line-" + _vm.lineType),
    style: (_vm.getIndent(_vm.level))
  }, [_c('span', {
    staticClass: "c-json-mark"
  }, [_vm._v(_vm._s(_vm.line))]), _vm._v(" "), _c('span', {
    class: ("c-of-" + _vm.lineType)
  }), _vm._v(" "), _c('span', {
    staticClass: "c-json-content"
  }, [(_vm.showIndex) ? _c('span', {
    staticClass: "c-json-key"
  }, [_vm._v(_vm._s(_vm.name) + ": ")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: ("c-json-" + _vm.type)
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('span', {
    staticClass: "c-json-comma"
  }, [_vm._v(_vm._s(_vm.needComma ? ',' : ''))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc538ebc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-json-compare/src/normalTree.vue
// module id = 1209
// module chunks = 39